import { memo as Memo, useEffect, useRef } from 'react';
import gsap from 'gsap/all';

//* Styles
import GameServiceStyle from './style';
import CustomLottie from '../../CustomLottie';
import gameServiceLottieJSON from './gameServiceLottie.json';

const GameService = Memo(() => {
	const contRef = useRef();

	return (
		<GameServiceStyle
			ref={contRef}
			className={'GameServiceCont'}>
			<CustomLottie
				display='flex'
				animData={gameServiceLottieJSON}
				isStopped={false}
			/>
		</GameServiceStyle>
	);
});

export default GameService;
